import { AwardIcon, ExternalLinkIcon } from "lucide-react";

import {
  SheetSectionContainer,
  SheetSectionEmptyText,
  SheetSectionHeader,
} from "@/components";
import { Button } from "@/components/ui/button";

import { dates } from "@/lib/dates";
import { Certification } from "@/types";

export const SheetCertifications = ({
  certifications,
  showResumeCertifications,
}: {
  certifications: Certification[];
  showResumeCertifications?: boolean;
}) => {
  // Filter out certifications without names.
  let filteredCertifications = certifications.filter((certification) =>
    certification.name?.trim(),
  );

  // Filter out certifications that are not on the user's profile if applicable.
  filteredCertifications = showResumeCertifications
    ? filteredCertifications
    : filteredCertifications.filter(
        (certification) => !certification.isResumeField,
      );

  if (!filteredCertifications.length) {
    return (
      <SheetSectionContainer>
        <SheetSectionHeader
          icon={AwardIcon}
          title="Certifications / Licenses"
          isEmpty
        />
        <SheetSectionEmptyText text="This candidate hasn't added any certifications." />
      </SheetSectionContainer>
    );
  }

  return (
    <SheetSectionContainer>
      <SheetSectionHeader icon={AwardIcon} title="Certifications" />
      <div>
        {filteredCertifications.map((certification: Certification, i) => {
          const dateDisplay =
            dates.prepareDateDisplayForCertificationOrEducationOrWorkExperience(
              {
                startMonth: certification.startMonth,
                startYear: certification.startYear,
                endMonth: certification.endMonth,
                endYear: certification.endYear,
                current: null,
              },
            );

          let organizationAndDateDisplay = "";
          if (certification.organization && dateDisplay) {
            organizationAndDateDisplay = `${certification.organization} • ${dateDisplay}`;
          } else if (certification.organization) {
            organizationAndDateDisplay = certification.organization;
          } else if (dateDisplay) {
            organizationAndDateDisplay = dateDisplay;
          }

          return (
            <div className="flex items-center justify-between" key={i}>
              <div className="flex flex-col gap-1 py-2">
                <p className="font-medium text-slate-700">
                  {certification.name}
                  {certification.credentialId &&
                    ` • ${certification.credentialId}`}
                </p>
                {organizationAndDateDisplay && (
                  <p className="text-sm text-slate-600">
                    {organizationAndDateDisplay}
                  </p>
                )}
              </div>
              {certification.credentialUrl && (
                <Button
                  className="text-base font-semibold text-primary-900"
                  onClick={() => {
                    // @ts-expect-error: We checked that `credentialUrl` is defined above.
                    window.open(certification.credentialUrl, "_blank");
                  }}
                  variant="link"
                >
                  {/* TODO: See if the icon can be underlined... */}
                  <ExternalLinkIcon className="h-4 w-4" />
                  View
                </Button>
              )}
            </div>
          );
        })}
      </div>
    </SheetSectionContainer>
  );
};
